// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class Toggler extends WebComponent {
	didMount() {
    const {
      toggleClass,
      target,
    } = this.props;

    this.on('click', () => {
        this.element.classList.toggle(toggleClass);
        const isExpanded = this.element.classList.contains(toggleClass);
        this.element.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

        const targetElement = document.querySelector(target);
        targetElement.classList.toggle(toggleClass);

/*
        const openToggles = document.querySelectorAll('.' + toggleClass);
        openToggles.forEach((toggle) => {
          if ((toggle != this.element) && (toggle != targetElement)) {
            toggle.classList.remove(toggleClass);
            toggle.setAttribute('aria-expanded', 'false');
          }
        });
*/
    });
	}
}



// WEBPACK FOOTER //
// ./fe/web-uhkPoint/src/js/components/Toggler.js